import React, { useEffect, useState } from 'react'
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined'
import '../../css/rbac/RbacAssignedDataCard.scss'

export default function RbacAssignedDataCard({ title, children, icon, error = false }) {
  const [expanded, setExpanded] = useState(true)
  useEffect(() => {
    if (error) setExpanded(true)
  }, [error])

  return (
    <Accordion
      className={`rbac-assigned-data-card${error ? ' rbac-assigned-data-card--error' : ''}`}
      expanded={expanded}
      onChange={(_, next) => setExpanded(next)}
      disableGutters
      elevation={0}
    >
      <AccordionSummary
        className="rbac-assigned-data-card__summary"
        expandIcon={<ExpandMoreIcon className="rbac-assigned-data-card__expand-icon" />}
      >
        {icon && <Box className="rbac-assigned-data-card__icon">{icon}</Box>}
        <Box className="rbac-assigned-data-card__heading">
          <Typography className="rbac-assigned-data-card__title">{title}</Typography>
        </Box>
        {error && <ErrorOutlineOutlinedIcon className="rbac-assigned-data-card__error-icon" />}
      </AccordionSummary>
      <AccordionDetails className="rbac-assigned-data-card__details">{children}</AccordionDetails>
    </Accordion>
  )
}
